// Label tautan footer hak konten (Sesi L6).
// Modul kecil agar bisa diuji tanpa mengimpor seluruh Landing.
// strings.js terkunci (C10): salinan dwibahasa mengikuti pola kamus lokal modul L4.
export const RIGHTS_FOOTER_LABEL = { id: "Hak konten", en: "Content rights" };
export const RIGHTS_FOOTER_PATH = "/legal/hak-konten";
